import React from "react"
import { Body } from "components/Shell/Shell"
import { Receipt } from "./Receipt"
import { parseUrlQuery } from "utilities"
import {
  GET_WEB_CART_BY_REF_NUM,
  GET_REPORTS_BY_WEB_CART_REF_NUM,
  GET_APP_SETTING_BY_NAME
} from "requests"
import { PaymentError } from "./PaymentCallback"

export default class ReceiptPage extends React.Component {
  state = {
    receiptItems: null,
    receiptItemContainers: null,
    downloads: null,
    refNum: null,
    loading: true,
    downloadsLoading: true,
    error: false,
    errorCode: null,
    errorMessage: null,
    paymentMessage: "",
    isFree: true,
    additionalProps: {}
  }
  componentDidMount = () => {
    const query = parseUrlQuery(this.props.location.search)
    if (query.ref) {
      this.setState({refNum: query.ref})
      Promise.all([this.getWebCart(query.ref), this.getDownloads(query.ref)])
      .then(() => {
        this.setState({
          loading: false
        })
      })
      .catch(errs => {
        console.error(errs)
        this.setState({
          error: true,
          errorCode: query.RESULT,
          errorMessage: query.RESPMSG
        })
      })
    }
  }
  getWebCart = refNum => (
    new Promise((resolve, reject) => {
      GET_WEB_CART_BY_REF_NUM(
        refNum,
        webCart => {
          if (webCart) {
            this.setState({
              receiptItems: webCart.RECEIPT_ITEM_WEB_LIST,
              receiptItemContainers: webCart.RECEIPT_ITEM_CONTAINER_WEB_LIST,
              loading: false,
              isFree: webCart.IS_FREE,
              additionalProps: webCart.WEB_CART_ADDITIONAL_PROPS || {}
            })
            resolve()
          }
        },
        err => {
          reject(err)
        }
      )
    })
  )
  getDownloads = refNum => (
    new Promise((resolve, reject) => {
      GET_REPORTS_BY_WEB_CART_REF_NUM(refNum, downloads => {
        this.setState({downloads, downloadsLoading: false})
        resolve()
      }, err => {
        reject(err)
      })
    })
  )
  getSuccessMessage = () => (
    new Promise((resolve, reject) => {
      GET_APP_SETTING_BY_NAME('WEB_POST_FILING_MSG_COMPLETE', setting => {

      })
    })
  )
  render() {
    return (
      <Body className="receipt-wrapper" backgroundThemeColor="light-neutral">
        {!this.state.loading &&
          !this.state.downloadsLoading && (
            <Receipt
              animated={true}
              receiptItems={this.state.receiptItems}
              receiptItemContainers={this.state.receiptItemContainers}
              downloads={!Array.isArray(this.state.downloads) ? undefined : this.state.downloads}
              groupedDownloads={!Array.isArray(this.state.downloads) ? this.state.downloads : undefined}
              refNum={this.state.refNum}
              isFree={this.state.isFree}
              additionalProps={this.state.additionalProps}
            />
          )}
        {this.state.error && (
          <div className="payment-callback">
            <PaymentError
              errorCode={this.state.errorCode}
              errorMessage={this.state.errorMessage}
            />
          </div>
        )}
      </Body>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Checkout/ReceiptPage.js